import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
	selector: '[goRequiredFieldsNote]',
	standalone: true
})
export class RequiredFieldsNoteDirective implements OnInit {
	private readonly defaultNoteTranslationKey = 'common_required-fields-note';
	@Input() public goRequiredFieldsNote: string = this.defaultNoteTranslationKey;

	constructor (
		private elementRef: ElementRef<HTMLElement>,
		private renderer: Renderer2,
		private translate: TranslateService
	) {}

	public ngOnInit (): void {
		const hostElement = this.elementRef.nativeElement;
		const noteElement = this.renderer.createElement('p');
		const noteTranslationKey = this.goRequiredFieldsNote == null || this.goRequiredFieldsNote === ''
			? this.defaultNoteTranslationKey
			: this.goRequiredFieldsNote;
		const translatedNote = this.translate.instant(noteTranslationKey);
		this.renderer.addClass(noteElement, 'required-fields-note');
		this.renderer.setAttribute(noteElement, 'data-testid', 'required-fields-note');
		this.renderer.setStyle(noteElement, 'font-size', '12px');
		this.renderer.setStyle(noteElement, 'line-height', '16px');
		this.renderer.setStyle(noteElement, 'font-weight', '400');
		this.renderer.setStyle(noteElement, 'color', 'var(--color-text-subtle, #6b7280)');
		this.renderer.setStyle(noteElement, 'margin', '0 0 12px');
		this.renderer.setProperty(noteElement, 'textContent', translatedNote);

		if (hostElement.firstChild != null) {
			this.renderer.insertBefore(hostElement, noteElement, hostElement.firstChild);
			return;
		}

		this.renderer.appendChild(hostElement, noteElement);
	}
}
